export default "__VITE_ASSET__6fb9337c__"